// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__10mf7","col":"styles_col__G1Erc","fulfillmentStatus":"styles_fulfillmentStatus__1dPBR","emailCol":"styles_emailCol__3GN6D"};